var _path, _path2, _path3, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMessenger = function SvgMessenger(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33C25.8366 33 33 25.8366 33 17C33 8.16344 25.8366 1 17 1C8.16344 1 1 8.16344 1 17C1 25.8366 8.16344 33 17 33Z",
    fill: "white",
    stroke: "#EDF2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9049 23.1609V26.5761L14.0983 24.7606C14.9884 25.0172 15.9347 25.1557 16.9151 25.1557C22.1704 25.1557 26.4301 21.1806 26.4301 16.2778C26.4301 11.3746 22.1704 7.3999 16.9151 7.3999C11.66 7.3999 7.40002 11.3746 7.40002 16.2778C7.40002 19.0541 8.76594 21.5331 10.9049 23.1609Z",
    fill: "url(#paint0_linear_17_3654)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.899 13.8461L10.7676 19.2792L15.4376 16.7169L17.8776 19.2792L22.9801 13.8461L18.3619 16.3635L15.899 13.8461Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_3654",
    x1: 8.4619,
    y1: 8.69621,
    x2: 8.4619,
    y2: 25.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessenger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Messenger.3ab36307.svg";
export { ForwardRef as ReactComponent };